import { createSlice } from '@reduxjs/toolkit';
import { createOrder, uploadFile } from './actions';

const initialState = {
  data: {},
  image: {},
  status: 'idle', //'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

export const createOrderSlice = createSlice({
  name: 'createOrder',
  initialState,
  reducers: {
    // reducers goes here

    resetData: (state) => {
      state.data = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createOrder.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createOrder.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(createOrder.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(uploadFile.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(uploadFile.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(uploadFile.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.image = action.payload;
      });
  },
});

export const { resetData } = createOrderSlice.actions;
export default createOrderSlice.reducer;
